<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    <POSStore ref="posStore"/>
    <ShiftStore ref="shiftStore"/>
    <SyncTimestampsStore ref="syncTimestampsStore" :storeNames="['posStore', 'shiftStore']"/>
    <!-- ///////////////////////////////////////// -->

    <h1>POS Reconcilliation Report</h1>
    <!-- <p>ℹ️ Info: TODO</p> -->
    <GenericDatePeriodSelector storeName="syncTimestampsStore" dateKey="week" />
    <GenericDaysSelector storeName="syncTimestampsStore" />
    <!-- <ReconcilliationViewSelector storeName="shiftStore" /> -->
    
    <ExportToExcel 
      :tables="['RCGB', 'RMGB', 'WGB' ]" 
      bookName="POS Reconcilliation Report"
      storeName="syncTimestampsStore"
    />

    <div v-for="location in $locations" :key="location">
      <POSReconcilliationTable storeNames="['posStore', 'shiftStore']" :location="location"/>
      <div class="pagebreak"> </div>
    </div>
  </div>
</template>

<script>
import SyncTimestampsStore from '@/stores/SyncTimestampsStore.vue'
import POSStore from '@/pages/Reports/POS/Stores/POSStore.vue'
import ShiftStore from '@/pages/Reports/Shifts/Stores/ShiftStore.vue'
import POSReconcilliationTable from '@/pages/Reports/Reconcilliation/Components/POSReconcilliationTable.vue'

export default {
  name: 'POSReconcilliationReport',
  components:{
    SyncTimestampsStore, 
    ShiftStore, 
    POSStore,
    POSReconcilliationTable
  },
  provide(){
    return {
      reconcilliationPage: this,
      page: this,
    }
  },

}
</script>